import {AccordionToggle} from './accordion-toggle'
import {AvaCrop} from './avatar-cropper'
import {ChatInfiniteScroll} from './chat-infinite-scroll'
import {CloseAlert} from './close-alert'
import {ImageLightbox} from './image-lightbox'
import {DatePicker} from './datepicker'
import {DropdownHover} from './dropdown-hover'
import {DropdownToggle} from './dropdown-toggle'
import {Head} from './head'
import {Sticky} from './sticky'
import {Ionslider} from './slider'
import {ToggleChat} from './toggle-chat'
import {WaitForCSS} from './wait-for-css'
import {addthisToolbox} from './addthis-toolbox'

angular.module('app').directive('accordionToggle', () => new AccordionToggle());
angular.module('app').directive('avaCrop', () => new AvaCrop());
angular.module('app').directive('chatInfiniteScroll', () => new ChatInfiniteScroll());
angular.module('app').directive('closeAlert', () => new CloseAlert());
angular.module('app').directive('imageLightbox', () => new ImageLightbox());
angular.module('app').directive('datePicker', () => new DatePicker());
angular.module('app').directive('dropdownHover', () => new DropdownHover());
angular.module('app').directive('dropdownToggle', () => new DropdownToggle());
angular.module('app').directive('head', ['$rootScope', '$compile', ($rootScope, $compile) => new Head($rootScope, $compile)]);
angular.module('app').directive('sticky', ['$window', ($window) => new Sticky($window)]);
angular.module('app').directive('ionslider', ['$timeout', ($timeout) => new Ionslider($timeout)]);
angular.module('app').directive('toggleChat', ['$timeout', '$rootScope', 'LikeService', 'LockService', 'toastr', ($timeout, $rootScope, LikeService, LockService, toastr) => new ToggleChat($timeout, $rootScope, LikeService, LockService, toastr)]);
angular.module('app').directive('waitForCss', () => new WaitForCSS());
angular.module('app').directive('addthisToolbox', () => new addthisToolbox());
